const OmpFooter = () => {
  return (
    <footer className="omp-footer">
      <div className="omp-container">
        <div className="omp-layout-grid omp-footer-grid">
          <div className="omp-nav-col" aria-hidden="true" />
          <div className="omp-content-col">
            <div className="powered-by-solvpath">
              <span>Powered by</span>
              <img src="/assets/images/solvpath-logo.svg" alt="SolvPath" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default OmpFooter
